import React from 'react';
import { ListAction, ListActionInfo } from '@sweetgreen/garnish';

import { useLocalizationContext } from '@order/Localization';

import type { CheckoutDetailsBlockProps } from './CheckoutDetailsBlock.types';

export const CustomerOptions = React.memo(
  ({ customer }: CheckoutDetailsBlockProps) => {
    const { formatPhoneNumber } = useLocalizationContext();
    const phoneNumber = customer?.phoneNumber
      ? formatPhoneNumber({
          phoneNumber: customer.phoneNumber,
        }).national
      : '';

    if (!customer) return null;

    return (
      <ListActionInfo iconName="IconProfileStroke">
        <ListAction.Text>
          {customer.firstName}
          {phoneNumber ? `, ${phoneNumber}` : null}
        </ListAction.Text>
      </ListActionInfo>
    );
  },
);
